import { Box } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';

import { TopicsScores } from '@/domain/impact-calculate/entities/calculate.entity';

import { VenueMonthCard } from './VenueMonthCard';

export function CalendarsView({
  startDate,
  endDate,
  selectedDays = [],
  scoresByMonth = {},
  onClickDate,
}: {
  startDate: string;
  endDate: string;
  selectedDays?: string[];
  scoresByMonth?: Record<string, TopicsScores>;
  onClickDate: (date: Dayjs) => void;
}) {
  const selectedDaysConverted = selectedDays.map((date) => dayjs(date));

  const getScoreForMonth = (month: string) => {
    if (scoresByMonth[month]) {
      return scoresByMonth[month];
    }
    return {
      co2: '-',
      env: '-',
      ess: '-',
      totalMen: '-',
      totalWomen: '-',
      totalOther: '-',
    };
  };

  const months = getCalendarMonths(new Date(startDate), new Date(endDate));
  return (
    <Box
      gap={2}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
    >
      {months.map((month) => (
        <VenueMonthCard
          key={month}
          month={dayjs(month)}
          selectedDays={selectedDaysConverted}
          onClickDate={onClickDate}
          scores={getScoreForMonth(month)}
        />
      ))}
    </Box>
  );
}

function getCalendarMonths(start = new Date(), end = new Date()) {
  const date = new Date(start.getFullYear(), start.getMonth());
  const months = [];
  while (date <= end) {
    const month = date.getMonth() + 1;
    months.push(
      `${date.getFullYear()}-${
        month.toString().length === 2 ? month : `0${month}`
      }`,
    );
    date.setMonth(date.getMonth() + 1);
  }
  return months;
}
